module.exports = __webpack_public_path__ + "static/media/36.fc7b1c8a.png";